(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["native-winecush-choices"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lazenne-quantity-offers')) {
    customElements.define('lazenne-quantity-offers', class extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        this.addEventListener('click', event => {
          const button = event.target.closest('button[data-quantity]');
          const input = this.quantityInput;
          if (!button || !this.contains(button) || button.disabled || !input) return;
          input.value = button.dataset.quantity;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
          this.updateChoices();
        }, { signal });
        for (const type of ['input', 'change']) {
          document.addEventListener(type, event => {
            if (event.target === this.quantityInput) this.updateChoices();
          }, { signal });
        }
        requestAnimationFrame(() => { this.hidden = !this.quantityInput; this.updateChoices(); });
      }
      disconnectedCallback() { this.abortController?.abort(); }
      get quantityInput() {
        return document.getElementById(this.dataset.formId)?.elements.namedItem('quantity');
      }
      updateChoices() {
        const input = this.quantityInput;
        if (!input) return;
        const min = Number(input.min || 1), max = Number(input.max || Infinity), step = Number(input.step || 1);
        for (const button of this.querySelectorAll('button[data-quantity]')) {
          const quantity = Number(button.dataset.quantity);
          button.disabled = quantity < min || quantity > max || (quantity - min) % step !== 0;
          button.setAttribute('aria-pressed', String(quantity === Number(input.value)));
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (() => {
    let refreshTimer;
    const observeCards = () => {
      const main = document.querySelector('main') || document.getElementById('main');
      if (!main) return;

      new MutationObserver((mutations) => {
        const addedCards = mutations.some(({ addedNodes }) => [...addedNodes].some((node) =>
          node instanceof Element && (node.matches('.product-card__yotpo-rating') || node.querySelector('.product-card__yotpo-rating'))
        ));
        if (!addedCards) return;
        window.clearTimeout(refreshTimer);
        refreshTimer = window.setTimeout(() => {
          window.yotpoWidgetsContainer?.initWidgets?.();
        }, 100);
      }).observe(main, { childList: true, subtree: true });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeCards, { once: true });
    } else {
      observeCards();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
